export default __webpack_public_path__ + "static/media/kyoko.c89861d7.png";